// assets
import './bookNowDropdown.scss';

export default function BookNowDropdown() {
  const container = document.querySelector('[data-book-container]');
  const bookList = container.querySelector('[data-book-list]');

  if (container) {
    container.addEventListener('mouseover', () => {
      bookList.classList.add('is-open');
    });
    container.addEventListener('mouseout', () => {
      bookList.classList.remove('is-open');
    });
  }
}



// WEBPACK FOOTER //
// ./components/bookNowDropdown/bookNowDropdown.js